/**
 * Enum representing the selection style for the calendar chooser.
 *
 * @enum CalendarChooserSelectionStyle
 * @platform iOS
 */
export var CalendarChooserSelectionStyle;
(function (CalendarChooserSelectionStyle) {
    /**
     * Allows only a single selection in the calendar chooser.
     */
    CalendarChooserSelectionStyle[CalendarChooserSelectionStyle["SINGLE"] = 0] = "SINGLE";
    /**
     * Allows multiple selections in the calendar chooser.
     */
    CalendarChooserSelectionStyle[CalendarChooserSelectionStyle["MULTIPLE"] = 1] = "MULTIPLE";
})(CalendarChooserSelectionStyle || (CalendarChooserSelectionStyle = {}));
//# sourceMappingURL=calendar-chooser-selection-style.js.map